import { ISchedule } from "@gettactic/api";

export function getActualSchedule(
  schedules: ISchedule[] | undefined,
  startDate?: Date | null
) {
  if (!schedules || !schedules.length) return undefined;
  let i = 0;
  let scheduledUserEndTime =
    schedules?.[i]?.end && new Date(schedules?.[i]?.end.slice(0, -1) as never);
  let scheduledTimeOver =
    (scheduledUserEndTime && startDate && scheduledUserEndTime < startDate) ||
    (scheduledUserEndTime && scheduledUserEndTime < new Date());
  if (schedules.length > 1) {
    while (scheduledTimeOver && i < schedules.length - 1) {
      if (scheduledTimeOver) {
        i++;
      } else {
        break;
      }
      scheduledUserEndTime =
        schedules?.[i]?.end &&
        new Date(schedules?.[i]?.end.slice(0, -1) as never);
      scheduledTimeOver =
        (scheduledUserEndTime &&
          startDate &&
          scheduledUserEndTime < startDate) ||
        (scheduledUserEndTime && scheduledUserEndTime < new Date());
    }
  }
  return schedules[i];
}
